import React from 'react';

function bookingModalNormalizeHHMM(value, fallback = "10:00") {
  const match = String(value || "").trim().match(/^(\d{1,2}):(\d{2})$/);
  if (!match) return fallback;
  const hh = Number(match[1]);
  const mm = Number(match[2]);
  if (!Number.isFinite(hh) || !Number.isFinite(mm) || hh < 0 || hh > 23 || mm < 0 || mm > 59) return fallback;
  return `${String(hh).padStart(2, "0")}:${String(mm).padStart(2, "0")}`;
}

function bookingModalTimeParts(value) {
  const normalized = bookingModalNormalizeHHMM(value, "10:00");
  const [hhRaw, mmRaw] = normalized.split(":");
  const hour24 = Number(hhRaw);
  const period = hour24 >= 12 ? "PM" : "AM";
  const hour12 = hour24 % 12 || 12;
  return { hour12: String(hour12), minute: String(mmRaw || "00").padStart(2, "0"), period };
}

function bookingModalTimeFrom12hParts(hour12Value, minuteValue, periodValue) {
  let hour = Number(hour12Value || 12);
  const minute = Number(minuteValue || 0);
  const period = String(periodValue || "AM").toUpperCase() === "PM" ? "PM" : "AM";
  if (!Number.isFinite(hour) || hour < 1 || hour > 12) hour = 12;
  let hour24 = hour % 12;
  if (period === "PM") hour24 += 12;
  return `${String(hour24).padStart(2, "0")}:${String(Number.isFinite(minute) ? minute : 0).padStart(2, "0")}`;
}

function BookingModalTimeInput({ value, onChange, timeFormat = "24h" }) {
  const safeValue = bookingModalNormalizeHHMM(value, "10:00");
  if (timeFormat !== "12h") {
    return (
      <input
        className="loop-time24-input"
        type="time"
        aria-label="Hora de la reserva"
        step="60"
        value={bookingModalNormalizeHHMM(value, "")}
        onChange={(e) => onChange?.(bookingModalNormalizeHHMM(e.target.value, e.target.value))}
        placeholder="10:00"
        inputMode="numeric"
      />
    );
  }

  const parts = bookingModalTimeParts(safeValue);
  const hourOptions = Array.from({ length: 12 }, (_, i) => {
    const hour = String(i + 1);
    return { value: hour, label: hour };
  });
  const minuteOptions = Array.from({ length: 60 }, (_, minute) => String(minute).padStart(2, "0"))
    .sort((a, b) => Number(a) - Number(b))
    .map((minute) => ({ value: minute, label: minute }));
  const periodOptions = [
    { value: "AM", label: "AM" },
    { value: "PM", label: "PM" },
  ];
  const update = (patch) => {
    const next = { ...parts, ...patch };
    onChange?.(bookingModalTimeFrom12hParts(next.hour12, next.minute, next.period));
  };

  return (
    <div className="loop-time12-control loop-time12-control-modern" aria-label="Hora de la reserva">
      <select aria-label="Hora" value={parts.hour12} onChange={e => update({ hour12: e.target.value })}>
        {hourOptions.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
      </select>
      <span className="loop-time12-separator" aria-hidden="true">:</span>
      <select aria-label="Minutos" value={parts.minute} onChange={e => update({ minute: e.target.value })}>
        {minuteOptions.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
      </select>
      <select aria-label="AM o PM" value={parts.period} onChange={e => update({ period: e.target.value })}>
        {periodOptions.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
      </select>
    </div>
  );
}

export default BookingModalTimeInput;
